import { createAction } from "@reduxjs/toolkit";

const wsConnect = createAction("ws/connect");
const wsEvent = createAction("ws/event");

export { wsConnect, wsEvent };
